module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label', {
    staticClass: "gray--text"
  }, [_vm._v(_vm._s(_vm.label) + _vm._s(this.required !== undefined ? '*' : ''))]), _vm._v(" "), _c('p', {
    staticClass: "black--text body-1",
    attrs: {
      "align": _vm.align
    }
  }, [_c('pre', {
    staticClass: "black--text body-1"
  }, [_vm._v(_vm._s(_vm.value))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f518b658","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c-readonly-field-pre-format.vue
// module id = 474
// module chunks = 0